<template>
  <div class="vertical-center">
    <vs-button class="float-left mr-2" @click="openScan" icon-pack="feather" icon="icon-maximize" type="filled" size="small" color="primary">Scan</vs-button>
    <vs-popup class="holamundo"  title="Scan QR Here" :active.sync="popupActive">
      <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" :track="drawOutline">
        <div v-show="showScanConfirmation" class="scan-confirmation">
        </div>
      </qrcode-stream>
    </vs-popup>
  </div>
</template>

<script>
  import Vue from "vue";
  import { QrcodeStream } from 'vue-qrcode-reader'

  export default Vue.extend({
    name: 'DeviceRequestScan',
    components: { QrcodeStream },
    data() {
      return {
        value: '',
        popupActive:false,
        camera: 'off',
        result: null,
        showScanConfirmation: false,
      }
    },
    methods: {

      async onInit (promise) {
        try {
          await promise
        } catch (e) {
            alert(e)
        } finally {
          this.showScanConfirmation = this.camera === "off"
        }
      },

      async onDecode (content) {
          this.result = content
          this.popupActive = false
          let payload = {
            index : this.params.data.id,
            value : this.result
          }
          this.$root.$emit("scan-from-ScanAgGridComponent", payload)
      },

      unpause () {
        this.camera = 'auto'
      },

      pause () {
        this.camera = 'off'
      },

      timeout (ms) {
        return new Promise(resolve => {
          window.setTimeout(resolve, ms)
        })
      },

      drawOutline (detectedCodes, ctx) {
        for (const detectedCode of detectedCodes) {
          const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints

          ctx.strokeStyle = "green";
          ctx.lineWidth = 5
          ctx.beginPath();
          ctx.moveTo(firstPoint.x, firstPoint.y);
          for (const { x, y } of otherPoints) {
            ctx.lineTo(x, y);
          }
          ctx.lineTo(firstPoint.x, firstPoint.y);
          ctx.closePath();
          ctx.stroke();
        }
      },
      openScan(){
        this.popupActive = true
        this.camera = 'auto'
      }
    },
    watch: {
      popupActive: function (newValue, oldValue) {
        if (newValue === false) {
          this.camera = 'off'
        }
      }
    },
    mounted() {
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>

